import apiWrapper from '../../services/apiWrapper';

export const getLogs = async (logType, selectedDate) => {
  try {
    const formattedDate = selectedDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
    const response = await apiWrapper('get', `/logs/${logType}`, null, {
      params: { date: formattedDate }
    });

    return {
      success: true,
      logs: response
    };
  } catch (error) {
    console.error('Error fetching logs:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while fetching logs. Please try again later.'
    };
  }
};